module.exports = "/images/Singapore.png?36f038034f9571473518f53a62bd4d06";